// extracted by mini-css-extract-plugin
module.exports = {"type-switch-container":"_1f98N","typeSwitchContainer":"_1f98N","toggle-option":"WZAz4","toggleOption":"WZAz4","selected":"_3Kelk"};